import { ModulePermissions } from "types";

export const myCompany : ModulePermissions = {
  myCompany: {
    ICCoordinator: {},
    RCCoordinator: {},
  },
};
